export default {
  alarm: {
    device: '',
    start_time: '',
    end_time: ''
  }
}